"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfShiftBatchCreateDto = instanceOfShiftBatchCreateDto;
exports.ShiftBatchCreateDtoFromJSON = ShiftBatchCreateDtoFromJSON;
exports.ShiftBatchCreateDtoFromJSONTyped = ShiftBatchCreateDtoFromJSONTyped;
exports.ShiftBatchCreateDtoToJSON = ShiftBatchCreateDtoToJSON;
exports.ShiftBatchCreateDtoToJSONTyped = ShiftBatchCreateDtoToJSONTyped;
const OnCallShiftCreateDto_1 = require("./OnCallShiftCreateDto");
const ShiftDateDto_1 = require("./ShiftDateDto");
const DirectRequestFallback_1 = require("./DirectRequestFallback");
const StipendCreateDto_1 = require("./StipendCreateDto");
const ShiftType_1 = require("./ShiftType");
const LicenseType_1 = require("./LicenseType");
/**
 * Check if a given object implements the ShiftBatchCreateDto interface.
 */
function instanceOfShiftBatchCreateDto(value) {
    if (!('shiftType' in value) || value['shiftType'] === undefined)
        return false;
    if (!('licenseType' in value) || value['licenseType'] === undefined)
        return false;
    if (!('totalRate' in value) || value['totalRate'] === undefined)
        return false;
    if (!('facilityId' in value) || value['facilityId'] === undefined)
        return false;
    if (!('dates' in value) || value['dates'] === undefined)
        return false;
    return true;
}
function ShiftBatchCreateDtoFromJSON(json) {
    return ShiftBatchCreateDtoFromJSONTyped(json, false);
}
function ShiftBatchCreateDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'shiftType': (0, ShiftType_1.ShiftTypeFromJSON)(json['shiftType']),
        'licenseType': (0, LicenseType_1.LicenseTypeFromJSON)(json['licenseType']),
        'totalRate': json['totalRate'],
        'description': json['description'] == null ? undefined : json['description'],
        'isSearchable': json['isSearchable'] == null ? undefined : json['isSearchable'],
        'stipendMinimumDistance': json['stipendMinimumDistance'] == null ? undefined : json['stipendMinimumDistance'],
        'facilityId': json['facilityId'],
        'specialtyCode': json['specialtyCode'] == null ? undefined : json['specialtyCode'],
        'stipends': json['stipends'] == null ? undefined : (json['stipends'].map(StipendCreateDto_1.StipendCreateDtoFromJSON)),
        'onCallShift': json['onCallShift'] == null ? undefined : (0, OnCallShiftCreateDto_1.OnCallShiftCreateDtoFromJSON)(json['onCallShift']),
        'directRequestNurseId': json['directRequestNurseId'] == null ? undefined : json['directRequestNurseId'],
        'directRequestFallback': json['directRequestFallback'] == null ? undefined : (0, DirectRequestFallback_1.DirectRequestFallbackFromJSON)(json['directRequestFallback']),
        'dates': (json['dates'].map(ShiftDateDto_1.ShiftDateDtoFromJSON)),
    };
}
function ShiftBatchCreateDtoToJSON(json) {
    return ShiftBatchCreateDtoToJSONTyped(json, false);
}
function ShiftBatchCreateDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'shiftType': (0, ShiftType_1.ShiftTypeToJSON)(value['shiftType']),
        'licenseType': (0, LicenseType_1.LicenseTypeToJSON)(value['licenseType']),
        'totalRate': value['totalRate'],
        'description': value['description'],
        'isSearchable': value['isSearchable'],
        'stipendMinimumDistance': value['stipendMinimumDistance'],
        'facilityId': value['facilityId'],
        'specialtyCode': value['specialtyCode'],
        'stipends': value['stipends'] == null ? undefined : (value['stipends'].map(StipendCreateDto_1.StipendCreateDtoToJSON)),
        'onCallShift': (0, OnCallShiftCreateDto_1.OnCallShiftCreateDtoToJSON)(value['onCallShift']),
        'directRequestNurseId': value['directRequestNurseId'],
        'directRequestFallback': (0, DirectRequestFallback_1.DirectRequestFallbackToJSON)(value['directRequestFallback']),
        'dates': (value['dates'].map(ShiftDateDto_1.ShiftDateDtoToJSON)),
    };
}
//# sourceMappingURL=ShiftBatchCreateDto.js.map